var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62952 12.5172C7.92451 12.4882 8.20343 12.3691 8.42842 12.1761L14.4574 7.00711C14.6086 6.88706 14.7339 6.73777 14.826 6.56816C14.9181 6.39856 14.975 6.21213 14.9935 6.02002C15.0119 5.8279 14.9913 5.63405 14.9331 5.45005C14.8749 5.26604 14.7802 5.09567 14.6546 4.9491C14.5291 4.80254 14.3752 4.6828 14.2023 4.59704C14.0295 4.51128 13.841 4.46126 13.6484 4.44997C13.4557 4.43868 13.2628 4.46635 13.081 4.53134C12.8993 4.59632 12.7326 4.69728 12.5907 4.82818L7.49507 9.19716L2.39941 4.82706C2.25719 4.69823 2.09058 4.59921 1.90943 4.53587C1.72829 4.47253 1.53628 4.44615 1.34477 4.45829C1.15325 4.47043 0.966115 4.52084 0.794418 4.60655C0.622721 4.69226 0.469951 4.81152 0.345137 4.95728C0.220324 5.10305 0.126002 5.27235 0.0677468 5.4552C0.00949176 5.63804 -0.0115137 5.83071 0.00597233 6.02181C0.0234583 6.21291 0.0790808 6.39857 0.169552 6.5678C0.260022 6.73704 0.383505 6.88642 0.532699 7.00711L6.56172 12.1761C6.70799 12.3013 6.87781 12.3959 7.06118 12.4545C7.24455 12.5131 7.43778 12.5344 7.62952 12.5172Z",
    fill: "#5849A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2fe3ebce06a2264fccb3cac09cf63e4a.svg";
export { ForwardRef as ReactComponent };